export default function Marquee({ items, label }) {
    const row = (hidden) => (
        <ul
            aria-hidden={hidden || undefined}
            className="flex shrink-0 items-center gap-16 pr-16 sm:gap-24 sm:pr-24"
        >
            {items.map((item, i) => (
                <li
                    key={i}
                    className="whitespace-nowrap font-display text-xl font-semibold uppercase tracking-[0.18em] text-ink-3/70 sm:text-2xl"
                >
                    {item}
                </li>
            ))}
        </ul>
    );
    return (
        <div data-testid="partner-marquee" className="relative w-full overflow-hidden border-y border-line py-8 sm:py-10">
            {label && <p className="eyebrow container-x mb-8">{label}</p>}
            <div className="flex w-max marquee-track">
                {row(false)}
                {row(true)}
            </div>
        </div>
    );
}
